import { Injectable, Injector, OnDestroy } from '@angular/core';
import { CustomMultiCartFacade, MultiCartService, SavedCartService, StateWithMultiCart } from '@cart/data-access';
import { Store } from '@ngrx/store';
import { Cart, OCC_USER_ID_ANONYMOUS, UserIdService } from '@spartacus/core';
import { Observable, Subscription } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CustomMultiCartService extends MultiCartService implements OnDestroy {
  subscription = new Subscription();

  constructor(
    userIdService: UserIdService,
    store: Store<StateWithMultiCart>,
    private injector: Injector,
    private customMultiCartFacade: CustomMultiCartFacade,
  ) {
    super(store, userIdService);

    // создаем подписку на юзера, перезапрашивая корзинки после авторизации
    this.subscription.add(
      this.userIdService
        .getUserId()
        .pipe(map((userId: string) => userId === OCC_USER_ID_ANONYMOUS))
        .subscribe((isAnonymous: boolean) => {
          if (!isAnonymous) {
            /** Хоть и под капотом у спартакуса список грузится только для авторизованного пользователя
             * грузим это здесь, чтобы корзины загружались в момент авторизации.
             */
            this.loadCartList();
          }
        }),
    );
  }

  loadCartList(): void {
    // была циклическая зависимость между сервисами, поэтому пришлось юзать инжектор
    this.injector.get(SavedCartService).loadSavedCarts();
  }

  getCartById(cartId: string): Observable<Cart | undefined> {
    return this.getCarts().pipe(
      map((carts: Cart[]) =>
        carts.find((cart) => {
          return cart?.code === cartId || cart?.guid === cartId;
        }),
      ),
    );
  }

  addCartToList(cart: Cart, active = true): void {
    this.customMultiCartFacade.restoreCart(cart, active);
  }

  // метод, убивающий все(на самом деле почти все) корзинки аонима, перед тем,
  // как записать ему зашериную корзину
  resetAnonymousCartState(): void {
    this.userIdService
      .getUserId()
      .pipe(take(1))
      .subscribe((userId) => {
        if (userId === OCC_USER_ID_ANONYMOUS) {
          this.customMultiCartFacade.clearCartState();
        }
      });
  }

  cloneCart(cartId: string): void {
    this.customMultiCartFacade.cloneCart(cartId);
  }

  // выпиливаем корзину из стейта
  // без этого, тухлые корзинки не удаляются
  removeCart(cartId: string): void {
    this.customMultiCartFacade.removeCart(cartId);
  }

  removeAllEntries(userId: string, cartId: string): void {
    this.customMultiCartFacade.removeAllEntries(userId, cartId);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
